import LinkPolicy from "./link-policy";
export default LinkPolicy;
